// schema/marks/italic.ts
var ITALIC_SCHEMA = () => ({
  group: "text-style",
  parseDOM: [
    { tag: "i" },
    { tag: "em" },
    { style: "font-style=italic" },
    { style: "font-style=normal", clearMark: (m) => m.type.name == "em" }
  ],
  toDOM: () => ["i"]
});
var ITALIC_KEY = "italic";
var ITALIC = {
  [ITALIC_KEY]: ITALIC_SCHEMA
};
export {
  ITALIC,
  ITALIC_KEY,
  ITALIC_SCHEMA
};
